import { render } from "./SucaiGroup.vue?vue&type=template&id=2e36bf97&scoped=true"
import script from "./SucaiGroup.vue?vue&type=script&lang=js"
export * from "./SucaiGroup.vue?vue&type=script&lang=js"

import "./SucaiGroup.vue?vue&type=style&index=0&id=2e36bf97&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e36bf97"]])

export default __exports__